<template lang='pug' src='./Username.pug'></template>

<script>
  import Vue from 'vue'
  import { mapGetters } from 'vuex'
  import { router } from '../../router'
  import { noAuth } from '../../lib/errors'

  export default {
    name: 'Username',
    data: function () {
      return {
        showOptions: false
      }
    },
    computed: {
      ...mapGetters([
        'getMe'
      ])
    },
    methods: {
      logout: function () {
        return window.fetch(Vue.config.kQuotes.LOGOUT)
          .then(response => {
            if (response.status === 200) {
              router.push({ name: 'login' })
            }
          })
          .catch(() => noAuth())
      }
    }
  }
</script>

<style lang='css' src='./Username.css' scoped></style>



// WEBPACK FOOTER //
// Username.vue?24151ea4